'use client';

import { useOffSetTop } from '@larvitu/shared/react/hooks';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useMemo, useState } from 'react';

import { HeaderContextProvider } from '../context/HeaderContextProps';

import type { FC, PropsWithChildren } from 'react';

export interface HeaderProviderProps<TNav = unknown> {
  height?: number;
  desktopMinWidth?: number;
}

export const HeaderContextController: FC<
  PropsWithChildren<HeaderProviderProps>
> = ({ children, height: initialHeight = 100, desktopMinWidth = 1120 }) => {
  const [isTransparent, setIsTransparent] = useState( false );
  const [height, setHeight] = useState( initialHeight );
  const isDesktop = useMediaQuery( `(min-width:${desktopMinWidth}px)` );
  const isTouchScreen = useMediaQuery( '(hover: none)' );
  const isMobile = !isDesktop || isTouchScreen;
  const isScrolling = useOffSetTop( height );

  const value = useMemo(
    () => ({
      isScrolling,
      isDesktop,
      isMobile,
      isTouchScreen,
      isTransparent,
      setIsTransparent,
      height,
    }),
    [
      isScrolling,
      isDesktop,
      isMobile,
      isTouchScreen,
      isTransparent,
      setIsTransparent,
      height,
    ]
  );

  return (
    <HeaderContextProvider value={value}>
      {children}
    </HeaderContextProvider>
  );
};
